<template lang="pug">
  app-layout
    v-flex(xs12)
      v-container.py-0.elevation-1.white(fluid)
        v-tabs(slider-color="primary")
          v-tab(v-for="item in items" :key="item.route.name" :to="item.route") {{ item.text }}
      v-container(fluid)
        slot
</template>

<script>
import { ROUTES } from './config/new-flow';

export default {
  data() {
    return {
      items: ROUTES,
    };
  },
};
</script>